module.exports = __webpack_public_path__ + "img/guardians-of-cloudia.ddddc62.png";